// F1 Drivers Component
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableChart } from '../charts';

const DriversComponent = ({ data }) => {
  const [activeView, setActiveView] = useState('overview');
  const [selectedYear, setSelectedYear] = useState(null);
  const renderDriverTable = () => {
    // Debug: Log what data we're receiving
    console.log('DriversComponent - data:', data);
    console.log('DriversComponent - data.drivers:', data?.drivers);
    console.log('DriversComponent - drivers count:', data?.drivers?.length);

    if (!data || !data.drivers || data.drivers.length === 0) {
      return (
        <div className="theme-bg-secondary rounded-lg p-4">
          <p className="theme-secondary">No driver data available</p>
        </div>
      );
    }

    // Transform driver data to match expected structure
    const transformedDrivers = data.drivers.map(driver => ({
      ...driver,
      name: (
        <Link 
          to={`/f1/drivers/${driver.driverId}`}
          className="theme-primary hover:theme-accent hover:underline font-medium"
        >
          {`${driver.forename} ${driver.surname}`}
        </Link>
      ),
      team: driver.constructorRef || 'N/A',
      wins: driver.wins || 0,
      championships: driver.championships || 0
    }));

    return (

          <TableChart data={transformedDrivers}
            title="All Drivers"
            subtitle="Click on any driver name to view their detailed profile and statistics."
            config={{
              columns: [
                { key: 'name', label: 'Driver' },
                { key: 'nationality', label: 'Nationality' },
                { key: 'wins', label: 'Wins' },
                { key: 'championships', label: 'Championships' }
              ],
              sortable: true,
              searchable: true,
              sortBy: 'wins',
              sortDirection: 'desc',
              pagination: true,
              pageSize: 10,
              showHeader: true,
              rowHeight: 40,
              headerHeight: 40,
              showFooter: true,
              footerHeight: 40
            }}
          />
    );
  };

  return (
    <>
      <div className="mt-8">
        {renderDriverTable()}
      </div>
      <div className="mt-8">
        <h3 className="text-xl font-semibold theme-primary mb-4">Driver Categories</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="theme-bg-secondary rounded-lg p-4">
            <h4 className="font-semibold theme-primary mb-2">Active Drivers</h4>
            <p className="theme-secondary text-sm">
              Currently competing drivers with their current team information and recent performance.
            </p>
          </div>
          <div className="theme-bg-secondary rounded-lg p-4">
            <h4 className="font-semibold theme-primary mb-2">Legendary Drivers</h4>
            <p className="theme-secondary text-sm">
              Historical champions and legendary drivers who made significant impact on Formula 1.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export const driversConfig = {
  title: 'F1 Drivers',
  subtitle: 'Driver profiles, career statistics, and performance analysis from Formula 1 history',
  summary: ['Driver statistics', 'Career achievements', 'Performance data'],
  stats: [
    { 
      value: (data) => data?.drivers?.length || 0, 
      label: 'Total Drivers',
    },
    { 
      value: '77', 
      label: 'Race Winners',
    },
    { 
      value: '34', 
      label: 'World Champions',
    },
    { 
      value: '40+', 
      label: 'Nationalities',
    }
  ],
  component: DriversComponent
};

export default DriversComponent;
